<accredible-base-header *transloco="let t; lang: 'en|static' read: 'googlecloudcertified_credential_net.header'">

  <div identitySection>
    <a href="https://cloud.google.com/">
      <img src="assets/themes/googlecloudcertified.credential.net/images/google_cloud_logo.svg"
        [alt]="t('google_cloud_logo')">
    </a>
  </div>

  <div navigationSection>
    <sl-header-menu [extraDynamicMenuItems]="googleHeaderLinks"></sl-header-menu>
  </div>
</accredible-base-header>
